import React from 'react';
import { Form, Input, TextArea } from 'semantic-ui-react';

export default props => {
  const { showLabels, field, value, error, onChange, disabled } = props;
  const { label, placeholder, type, required, options, inputType } = field;
  const labelToDisplay = showLabels ? label.slice(0, 1).toUpperCase() + label.slice(1) : '';

  if (type === 'hidden') {
    // No UI element.
    return null;
  }

  if (type === 'select') {
    const updatedOptions = options.map(option => {
      return {
        key: option.value,
        value: option.value,
        text: option.label,
      };
    });

    return (
      <Form.Select
        disabled={disabled}
        error={error}
        required={required}
        key={label}
        name={label}
        label={labelToDisplay}
        placeholder={placeholder}
        value={value}
        labeled={false}
        options={updatedOptions}
        onChange={onChange}
      />
    );
  }

  return (
    <Form.Field
      disabled={disabled}
      error={error}
      required={required}
      key={label}
      name={label}
      label={labelToDisplay}
      placeholder={placeholder}
      control={type === 'input' ? Input : TextArea}
      value={value}
      onChange={onChange}
      type={inputType || 'text'}
    />
  );
};
